// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__J2AFM","container":"style_container__1L-++","text":"style_text__3YKNm","h":"style_h__PuSaz","m":"style_m__zZCAb","l":"style_l__Avoif"};